// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
// import bgImage from "assets/images/bg-reset-cover.jpeg";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useNavigate } from "react-router-dom";
import { useCallback, useState } from "react";
import { forgotPassword } from "tutor/services/password-service";
import useLoading from "hooks/use-loading";

function Cover() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [httpRequestError, setHttpRequestError] = useState(false);
  const [httpRequestErrorMessage, setHttpRequestErrorMessage] = useState("");

  const { setShowLoader } = useLoading();

  const isValidEmail = (email1) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email1);

  const onEmailChangeHandler = (e) => {
    if (isValidEmail(e.target.value)) {
      setHasError(false);
      setErrorMessage("");
    } else {
      setHasError(true);
      setErrorMessage("Please enter a valid email address");
    }
    setEmail(e.target.value);
  };

  const sendForgotPasswordLink = useCallback(async (email1) => {
    try {
      setShowLoader(true);
      const res = await forgotPassword(email1);
      if (res.status) {
        navigate("/authentication/sign-in");
        setHttpRequestError(false);
        setHttpRequestErrorMessage("");
      } else {
        setHttpRequestError(true);
        setHttpRequestErrorMessage(res.message);
      }
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      setHttpRequestError(true);
      // setHttpRequestErrorMessage(error.message);
      setHttpRequestErrorMessage("Something went wrong. Please try again later.");
    }
  }, []);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (!hasError) {
      sendForgotPasswordLink(email);
    }
  };

  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Forgot Password
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            You will receive an e-mail in maximum 60 seconds
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {httpRequestError && (
            <MDTypography variant="h6" color="error" align="center" style={{ fontSize: "13px" }}>
              {httpRequestErrorMessage}
            </MDTypography>
          )}
          <form onSubmit={onSubmitHandler}>
            <MDBox mb={4}>
              <MDInput
                error={hasError}
                helperText={errorMessage}
                onChange={onEmailChangeHandler}
                value={email}
                type="email"
                label="Email"
                variant="standard"
                fullWidth
              />
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                reset
              </MDButton>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
